import { QuizQuestion } from '../../types';

export const llmFoundationsModule1QuestionBank: QuizQuestion[] = [
  // Basic Concepts (1-10)
  {
    id: 'llm-q1',
    question: 'What does LLM stand for?',
    choices: [
      'Limited Language Model',
      'Large Language Model',
      'Linear Learning Machine',
      'Logical Language Module',
    ],
    correctAnswer: 1,
    explanation:
      'LLM stands for Large Language Model, referring to AI systems with billions to trillions of parameters trained on vast text data.',
  },
  {
    id: 'llm-q2',
    question: 'Which of the following best describes a Large Language Model?',
    choices: [
      'A database of pre-written responses',
      'A rule-based system for language translation',
      'A pattern recognition system trained on vast amounts of text',
      'A search engine that retrieves information',
    ],
    correctAnswer: 2,
    explanation:
      'LLMs are pattern recognition systems trained on vast text data, not databases or rule-based systems.',
  },
  {
    id: 'llm-q3',
    question: 'What are parameters in the context of LLMs?',
    choices: [
      'User settings for the model',
      'Adjustable values that store learned patterns',
      'Input variables from users',
      'Output format specifications',
    ],
    correctAnswer: 1,
    explanation:
      'Parameters are the adjustable values in the neural network that store learned patterns during training.',
  },
  {
    id: 'llm-q4',
    question: 'Modern LLMs typically contain how many parameters?',
    choices: [
      'Thousands to millions',
      'Millions to billions',
      'Billions to trillions',
      'Trillions to quadrillions',
    ],
    correctAnswer: 2,
    explanation: 'Modern LLMs like GPT-3/4 and Claude contain billions to trillions of parameters.',
  },
  {
    id: 'llm-q5',
    question: 'What is the primary training approach for LLMs?',
    choices: [
      'Supervised learning with labeled data',
      'Reinforcement learning from human feedback only',
      'Self-supervised learning from raw text',
      'Rule-based programming',
    ],
    correctAnswer: 2,
    explanation:
      'LLMs primarily use self-supervised learning from raw text data, predicting next tokens.',
  },
  {
    id: 'llm-q6',
    question: 'Which statement about LLM understanding is most accurate?',
    choices: [
      'LLMs truly understand language like humans',
      'LLMs have consciousness and awareness',
      'LLMs recognize statistical patterns in text',
      'LLMs have real-world experiences',
    ],
    correctAnswer: 2,
    explanation:
      "LLMs recognize statistical patterns; they don't truly understand or have consciousness.",
  },
  {
    id: 'llm-q7',
    question: 'What type of data are LLMs primarily trained on?',
    choices: [
      'Structured databases',
      'Images and videos',
      'Text from books, websites, and articles',
      'Audio recordings',
    ],
    correctAnswer: 2,
    explanation: 'Text data from various sources is the primary training data for language models.',
  },
  {
    id: 'llm-q8',
    question: 'The computational requirements for training large LLMs typically involve:',
    choices: [
      'A single powerful computer',
      'A few desktop computers',
      'Thousands of GPUs in distributed systems',
      'Quantum computers only',
    ],
    correctAnswer: 2,
    explanation:
      'Training large LLMs requires massive distributed computing with thousands of GPUs.',
  },
  {
    id: 'llm-q9',
    question: 'Which capability is NOT typical of current LLMs?',
    choices: [
      'Text generation',
      'Language translation',
      'Real-time internet browsing',
      'Question answering',
    ],
    correctAnswer: 2,
    explanation:
      'Current LLMs cannot browse the internet in real-time; they work with training data.',
  },
  {
    id: 'llm-q10',
    question: 'What makes LLMs "generative" models?',
    choices: [
      'They generate electricity',
      'They create new text based on patterns',
      'They generate random numbers',
      'They only copy existing text',
    ],
    correctAnswer: 1,
    explanation: 'Generative means creating new text based on learned patterns, not copying.',
  },

  // Evolution and History (11-20)
  {
    id: 'llm-q11',
    question: 'When was the transformer architecture, fundamental to modern LLMs, introduced?',
    choices: ['2010', '2015', '2017', '2020'],
    correctAnswer: 2,
    explanation:
      'The transformer architecture was introduced in the 2017 "Attention Is All You Need" paper.',
  },
  {
    id: 'llm-q12',
    question: 'Which model is considered the breakthrough for few-shot learning?',
    choices: ['BERT', 'GPT-2', 'GPT-3', 'Word2Vec'],
    correctAnswer: 2,
    explanation:
      'GPT-3 demonstrated breakthrough few-shot learning capabilities with its 175B parameters.',
  },
  {
    id: 'llm-q13',
    question: 'What was the approximate parameter count of GPT-3?',
    choices: ['1.5 billion', '17.5 billion', '175 billion', '1.75 trillion'],
    correctAnswer: 2,
    explanation: 'GPT-3 has approximately 175 billion parameters.',
  },
  {
    id: 'llm-q14',
    question: 'Rule-based NLP systems were dominant in which era?',
    choices: ['1950s-1960s', '1990s-2000s', '2010s', '2020s'],
    correctAnswer: 0,
    explanation: 'Rule-based systems dominated early NLP in the 1950s-1960s.',
  },
  {
    id: 'llm-q15',
    question: 'What major shift occurred from traditional NLP to modern LLMs?',
    choices: [
      'From self-supervised to supervised learning',
      'From general models to task-specific models',
      'From task-specific models to general-purpose models',
      'From large models to small models',
    ],
    correctAnswer: 2,
    explanation: 'The shift was from task-specific models to general-purpose models.',
  },
  {
    id: 'llm-q16',
    question: 'Word2Vec, introduced in 2013, pioneered what concept?',
    choices: [
      'Attention mechanisms',
      'Word embeddings as vectors',
      'Transformer architecture',
      'Few-shot learning',
    ],
    correctAnswer: 1,
    explanation:
      'Word2Vec pioneered representing words as dense vectors capturing semantic meaning.',
  },
  {
    id: 'llm-q17',
    question: 'Which model made LLMs accessible to the general public?',
    choices: ['BERT', 'GPT-2', 'ChatGPT', 'Word2Vec'],
    correctAnswer: 2,
    explanation: 'ChatGPT made LLMs accessible to millions of users worldwide.',
  },
  {
    id: 'llm-q18',
    question: 'Statistical NLP methods emerged prominently in which decade?',
    choices: ['1960s', '1980s-1990s', '2000s', '2010s'],
    correctAnswer: 1,
    explanation: 'Statistical methods emerged prominently in the 1980s-1990s.',
  },
  {
    id: 'llm-q19',
    question: 'What is the key difference between BERT and GPT architectures?',
    choices: [
      'BERT is much larger',
      'BERT uses bidirectional context, GPT uses unidirectional',
      'GPT cannot do classification tasks',
      "BERT doesn't use transformers",
    ],
    correctAnswer: 1,
    explanation:
      'BERT uses bidirectional context while GPT uses unidirectional (left-to-right) processing.',
  },
  {
    id: 'llm-q20',
    question: 'The progression from millions to billions of parameters occurred primarily:',
    choices: ['Between 1990-2000', 'Between 2000-2010', 'Between 2010-2020', 'After 2020'],
    correctAnswer: 2,
    explanation: 'The major scaling from millions to billions happened between 2010-2020.',
  },

  // Capabilities and Limitations (21-35)
  {
    id: 'llm-q21',
    question: 'Which of these is a major limitation of LLMs?',
    choices: [
      'Cannot generate text',
      'Hallucination of false information',
      'Cannot process English',
      'Require internet to function',
    ],
    correctAnswer: 1,
    explanation: 'Hallucination (generating false information confidently) is a major limitation.',
  },
  {
    id: 'llm-q22',
    question: 'What is "hallucination" in the context of LLMs?',
    choices: [
      'Visual artifacts in output',
      'Generating false or nonsensical information confidently',
      'Producing poetry',
      'Creating images',
    ],
    correctAnswer: 1,
    explanation: 'Hallucination means confidently generating false or nonsensical information.',
  },
  {
    id: 'llm-q23',
    question: 'Context window limitation means:',
    choices: [
      "Models can't see through windows",
      'Models can only process a limited amount of text at once',
      'Models only work on Windows OS',
      "Models can't understand context",
    ],
    correctAnswer: 1,
    explanation: 'Context window limitation refers to processing limited text at once.',
  },
  {
    id: 'llm-q24',
    question: 'Which task would LLMs typically struggle with most?',
    choices: [
      'Writing a poem',
      'Translating languages',
      'Real-time stock price lookup',
      'Summarizing text',
    ],
    correctAnswer: 2,
    explanation: 'Real-time data lookup is impossible without internet access.',
  },
  {
    id: 'llm-q25',
    question: 'Few-shot learning refers to:',
    choices: [
      'Learning from just a few examples in the prompt',
      'Training the model quickly',
      'Using small models',
      'Making few mistakes',
    ],
    correctAnswer: 0,
    explanation:
      'Few-shot learning means learning from just a few examples provided in the prompt.',
  },
  {
    id: 'llm-q26',
    question: 'Zero-shot learning means:',
    choices: [
      'The model has zero training',
      'Performing tasks without any examples',
      'The model makes zero errors',
      'Training with zero data',
    ],
    correctAnswer: 1,
    explanation: 'Zero-shot means performing tasks without any examples, just instructions.',
  },
  {
    id: 'llm-q27',
    question: 'Which application is most suitable for current LLMs?',
    choices: [
      'Controlling nuclear reactors',
      'Real-time surgical procedures',
      'Content creation and editing',
      'Autonomous vehicle navigation',
    ],
    correctAnswer: 2,
    explanation: 'Content creation is ideal for LLMs; critical real-time tasks are not suitable.',
  },
  {
    id: 'llm-q28',
    question: 'The knowledge cutoff of an LLM refers to:',
    choices: [
      'Maximum IQ of the model',
      'The date after which it has no training data',
      'How much it can remember',
      'The speed of processing',
    ],
    correctAnswer: 1,
    explanation: 'Knowledge cutoff is the date after which the model has no training data.',
  },
  {
    id: 'llm-q29',
    question: 'Which statement about LLM consistency is true?',
    choices: [
      'LLMs always give identical outputs for the same input',
      'LLMs may give different outputs for the same input',
      'LLMs cannot maintain consistency across sentences',
      'LLMs are 100% deterministic',
    ],
    correctAnswer: 1,
    explanation: 'LLMs may give different outputs due to probabilistic generation.',
  },
  {
    id: 'llm-q30',
    question: 'What makes LLMs different from traditional search engines?',
    choices: [
      'LLMs are faster',
      'LLMs generate new text rather than retrieve existing content',
      'LLMs have internet access',
      'LLMs are more accurate',
    ],
    correctAnswer: 1,
    explanation: 'LLMs generate new text rather than retrieve existing content.',
  },
  {
    id: 'llm-q31',
    question: 'Which industry has NOT seen significant LLM applications?',
    choices: [
      'Healthcare documentation',
      'Software development',
      'Physical manufacturing assembly',
      'Customer service',
    ],
    correctAnswer: 2,
    explanation: "Physical manufacturing assembly hasn't seen significant LLM application.",
  },
  {
    id: 'llm-q32',
    question: 'LLMs can assist in code generation by:',
    choices: [
      'Writing code from natural language descriptions',
      'Physically typing on keyboards',
      'Installing software',
      'Building hardware',
    ],
    correctAnswer: 0,
    explanation: 'LLMs can write code from natural language descriptions.',
  },
  {
    id: 'llm-q33',
    question: 'The main environmental concern with LLMs is:',
    choices: [
      'Water usage',
      'Energy consumption for training and inference',
      'Physical waste',
      'Noise pollution',
    ],
    correctAnswer: 1,
    explanation: 'Energy consumption for training and inference is the main environmental concern.',
  },
  {
    id: 'llm-q34',
    question: 'Which capability emerged unexpectedly from LLM scale?',
    choices: [
      'Text generation',
      'Complex reasoning chains',
      'Character recognition',
      'Audio processing',
    ],
    correctAnswer: 1,
    explanation: 'Complex reasoning chains emerged unexpectedly as models scaled up.',
  },
  {
    id: 'llm-q35',
    question: 'What is prompt engineering?',
    choices: [
      'Building physical computers',
      'Crafting inputs to get desired outputs from LLMs',
      'Training new models',
      'Fixing broken prompts',
    ],
    correctAnswer: 1,
    explanation: 'Prompt engineering is crafting inputs to get desired outputs from LLMs.',
  },

  // AI Landscape (36-45)
  {
    id: 'llm-q36',
    question: 'LLMs are currently classified as which type of AI?',
    choices: [
      'Artificial General Intelligence (AGI)',
      'Artificial Narrow Intelligence (ANI)',
      'Artificial Superintelligence (ASI)',
      'Natural Intelligence',
    ],
    correctAnswer: 1,
    explanation:
      'LLMs are currently Artificial Narrow Intelligence (ANI), though pushing boundaries.',
  },
  {
    id: 'llm-q37',
    question: 'Which AI paradigm do LLMs primarily belong to?',
    choices: ['Symbolic AI', 'Expert Systems', 'Foundation Models', 'Genetic Algorithms'],
    correctAnswer: 2,
    explanation:
      'LLMs are Foundation Models - large models trained broadly and adapted for many tasks.',
  },
  {
    id: 'llm-q38',
    question: 'Foundation models are characterized by:',
    choices: [
      'Being small and specific',
      'Being trained on broad data and adapted for many tasks',
      'Only working for one language',
      'Requiring minimal computation',
    ],
    correctAnswer: 1,
    explanation:
      'Foundation models are trained broadly and can be adapted for many different tasks.',
  },
  {
    id: 'llm-q39',
    question: 'How do LLMs compare to traditional expert systems?',
    choices: [
      'LLMs use rigid rules like expert systems',
      'LLMs learn patterns while expert systems use programmed rules',
      'Expert systems are more flexible',
      'They are essentially the same',
    ],
    correctAnswer: 1,
    explanation:
      'LLMs learn patterns from data while expert systems use explicitly programmed rules.',
  },
  {
    id: 'llm-q40',
    question: "The transformer architecture's key innovation was:",
    choices: [
      'Convolution layers',
      'Recurrent connections',
      'Attention mechanisms',
      'Decision trees',
    ],
    correctAnswer: 2,
    explanation: 'Attention mechanisms were the key innovation enabling transformers.',
  },
  {
    id: 'llm-q41',
    question: 'Which is NOT a characteristic of symbolic AI?',
    choices: [
      'Explicit rules',
      'Learning from data',
      'Logical reasoning',
      'Interpretable decisions',
    ],
    correctAnswer: 1,
    explanation:
      'Learning from data is not characteristic of symbolic AI, which uses explicit rules.',
  },
  {
    id: 'llm-q42',
    question: 'Multimodal models combine:',
    choices: [
      'Multiple languages only',
      'Different types of data (text, images, etc.)',
      'Multiple algorithms',
      'Several databases',
    ],
    correctAnswer: 1,
    explanation: 'Multimodal models combine different data types like text, images, and audio.',
  },
  {
    id: 'llm-q43',
    question: 'The path from ANI to AGI requires:',
    choices: [
      'Just larger models',
      'Capabilities like reasoning, planning, and general intelligence',
      'Faster computers only',
      'More training data only',
    ],
    correctAnswer: 1,
    explanation:
      'AGI requires capabilities like reasoning, planning, and general intelligence beyond scale.',
  },
  {
    id: 'llm-q44',
    question: 'Reinforcement Learning from Human Feedback (RLHF) is used to:',
    choices: [
      'Make models larger',
      'Align model behavior with human preferences',
      'Speed up training',
      'Reduce costs',
    ],
    correctAnswer: 1,
    explanation: 'RLHF aligns model behavior with human preferences and values.',
  },
  {
    id: 'llm-q45',
    question: 'Which approach combines neural networks with symbolic reasoning?',
    choices: ['Pure deep learning', 'Neuro-symbolic AI', 'Classical AI', 'Genetic programming'],
    correctAnswer: 1,
    explanation: 'Neuro-symbolic AI combines neural networks with symbolic reasoning.',
  },

  // Economic and Business Impact (46-55)
  {
    id: 'llm-q46',
    question: 'The projected LLM market size by 2030 is approximately:',
    choices: ['$25 billion', '$75 billion', '$260 billion', '$500 billion'],
    correctAnswer: 2,
    explanation: 'Projected market size by 2030 is approximately $260 billion.',
  },
  {
    id: 'llm-q47',
    question: 'What is the estimated productivity gain from LLM adoption in knowledge work?',
    choices: ['5-10%', '10-20%', '30-70%', '90-100%'],
    correctAnswer: 2,
    explanation: 'Estimated productivity gains in knowledge work are 30-70%.',
  },
  {
    id: 'llm-q48',
    question: 'Which business model has been most disrupted by LLMs?',
    choices: ['Manufacturing', 'Content creation', 'Agriculture', 'Construction'],
    correctAnswer: 1,
    explanation: 'Content creation has been most disrupted by LLM capabilities.',
  },
  {
    id: 'llm-q49',
    question: 'The main cost consideration for enterprise LLM adoption is:',
    choices: [
      'Hardware purchase',
      'Per-token API usage and infrastructure',
      'Office space',
      'Employee salaries',
    ],
    correctAnswer: 1,
    explanation: 'Per-token API usage and infrastructure are the main cost considerations.',
  },
  {
    id: 'llm-q50',
    question: 'ROI from LLM implementation typically comes from:',
    choices: [
      'Selling the models',
      'Productivity gains and automation',
      'Advertising revenue',
      'Government subsidies',
    ],
    correctAnswer: 1,
    explanation: 'ROI comes primarily from productivity gains and automation of tasks.',
  },
  {
    id: 'llm-q51',
    question: 'Which job role has emerged due to LLMs?',
    choices: ['Data entry clerk', 'Prompt engineer', 'Typewriter repair', 'Telegraph operator'],
    correctAnswer: 1,
    explanation: 'Prompt engineer is a new role created by the rise of LLMs.',
  },
  {
    id: 'llm-q52',
    question: 'Small companies can compete with large ones using LLMs because:',
    choices: [
      'LLMs are free',
      'LLMs democratize access to capabilities',
      "Large companies can't use LLMs",
      'Government regulations',
    ],
    correctAnswer: 1,
    explanation:
      'LLMs democratize access to advanced capabilities previously only available to large companies.',
  },
  {
    id: 'llm-q53',
    question: 'The "build vs. buy" decision for LLMs usually involves choosing between:',
    choices: [
      'Different computers',
      'Training custom models vs. using API services',
      'Hiring employees vs. using LLMs',
      'Different programming languages',
    ],
    correctAnswer: 1,
    explanation: 'The choice is between training custom models vs. using API services.',
  },
  {
    id: 'llm-q54',
    question: 'Which metric is NOT typically used to measure LLM ROI?',
    choices: ['Time saved', 'Error reduction', 'Physical output', 'Customer satisfaction'],
    correctAnswer: 2,
    explanation: 'Physical output is not a typical LLM ROI metric as they are software systems.',
  },
  {
    id: 'llm-q55',
    question: 'Enterprise adoption of LLMs is currently in which phase (as of 2024)?',
    choices: [
      'Experimentation only',
      'Moving from experimentation to integration',
      'Full transformation',
      'Decline',
    ],
    correctAnswer: 1,
    explanation: 'Enterprise adoption is moving from experimentation to production integration.',
  },

  // Ethical and Societal Impact (56-65)
  {
    id: 'llm-q56',
    question: 'Which ethical principle involves maximizing benefits to humanity?',
    choices: ['Maleficence', 'Beneficence', 'Autonomy', 'Justice'],
    correctAnswer: 1,
    explanation: 'Beneficence is the principle of maximizing benefits to humanity.',
  },
  {
    id: 'llm-q57',
    question: 'The main source of bias in LLMs is:',
    choices: [
      'Programming errors',
      'Training data reflecting societal biases',
      'Hardware limitations',
      'User inputs only',
    ],
    correctAnswer: 1,
    explanation: 'Training data reflecting existing societal biases is the main source.',
  },
  {
    id: 'llm-q58',
    question: 'Which is NOT a major ethical concern with LLMs?',
    choices: [
      'Privacy violations',
      'Misinformation spread',
      'Processing speed',
      'Bias amplification',
    ],
    correctAnswer: 2,
    explanation: 'Processing speed is a performance issue, not an ethical concern.',
  },
  {
    id: 'llm-q59',
    question: 'The "digital divide" in LLM context refers to:',
    choices: [
      'Screen resolution',
      'Unequal access to AI technology',
      'Binary numbers',
      'Computer brands',
    ],
    correctAnswer: 1,
    explanation: 'Digital divide refers to unequal access to AI technology and capabilities.',
  },
  {
    id: 'llm-q60',
    question: 'Which regulatory approach has the EU taken toward AI?',
    choices: [
      'Complete ban',
      'Risk-based regulation',
      'No regulation',
      'Industry self-regulation only',
    ],
    correctAnswer: 1,
    explanation: 'The EU has adopted a risk-based regulation approach with the AI Act.',
  },
  {
    id: 'llm-q61',
    question: 'Transparency in LLMs is challenging because:',
    choices: [
      'Models are too small',
      'Black box nature of neural networks',
      "Companies don't exist",
      "Users don't care",
    ],
    correctAnswer: 1,
    explanation: 'The black box nature of neural networks makes transparency challenging.',
  },
  {
    id: 'llm-q62',
    question: 'The environmental impact of LLMs primarily comes from:',
    choices: [
      'Paper usage',
      'Energy consumption in data centers',
      'Plastic waste',
      'Water pollution',
    ],
    correctAnswer: 1,
    explanation:
      'Energy consumption in data centers for training and inference is the main impact.',
  },
  {
    id: 'llm-q63',
    question: 'Which group is most at risk from LLM job displacement?',
    choices: [
      'Physical laborers',
      'Knowledge workers doing routine tasks',
      'Athletes',
      'Musicians',
    ],
    correctAnswer: 1,
    explanation: 'Knowledge workers doing routine, repetitive tasks are most at risk.',
  },
  {
    id: 'llm-q64',
    question: '"Constitutional AI" refers to:',
    choices: [
      'Government use of AI',
      'Training AI with built-in principles and values',
      'AI for lawyers',
      'Historical document analysis',
    ],
    correctAnswer: 1,
    explanation: 'Constitutional AI means training AI systems with built-in principles and values.',
  },
  {
    id: 'llm-q65',
    question: 'The main challenge in LLM accountability is:',
    choices: [
      'Models are too fast',
      'Determining responsibility for AI decisions',
      'Cost of insurance',
      'Technical documentation',
    ],
    correctAnswer: 1,
    explanation:
      'Determining who is responsible for AI-generated decisions and content is the main challenge.',
  },

  // Tokens and Tokenization (66-75)
  {
    id: 'llm-q66',
    question: 'A token in LLM context is:',
    choices: [
      'A security credential',
      'The basic unit of text processing',
      'A reward system',
      'A type of cryptocurrency',
    ],
    correctAnswer: 1,
    explanation: 'A token is the basic unit of text that an LLM processes.',
  },
  {
    id: 'llm-q67',
    question: 'On average, how many tokens make up an English word?',
    choices: ['0.25 tokens', '0.75 tokens', '1.3 tokens', '3 tokens'],
    correctAnswer: 2,
    explanation: 'On average, one English word corresponds to approximately 1.3 tokens.',
  },
  {
    id: 'llm-q68',
    question: 'Which tokenization approach is most common in modern LLMs?',
    choices: ['Character-level', 'Word-level', 'Subword (BPE/WordPiece)', 'Sentence-level'],
    correctAnswer: 2,
    explanation:
      'Subword tokenization (BPE/WordPiece) is most common, balancing vocabulary size and coverage.',
  },
  {
    id: 'llm-q69',
    question: 'Why is tokenization important for cost estimation?',
    choices: [
      'Tokens determine color',
      'API pricing is often per token',
      'Tokens are free',
      "It's not important",
    ],
    correctAnswer: 1,
    explanation: 'API pricing is often based on token usage, making accurate estimation important.',
  },
  {
    id: 'llm-q70',
    question: 'The main advantage of subword tokenization is:',
    choices: [
      'Smaller vocabulary size',
      'Handling unknown words gracefully',
      'Faster processing',
      'Both smaller vocabulary and handling unknown words',
    ],
    correctAnswer: 3,
    explanation:
      'Subword tokenization provides both smaller vocabulary size and graceful handling of unknown words.',
  },
  {
    id: 'llm-q71',
    question: 'Special tokens like [START] and [END] are used for:',
    choices: ['Decoration', 'Signaling sequence boundaries', 'Errors', 'Testing only'],
    correctAnswer: 1,
    explanation: 'Special tokens signal important boundaries in sequences.',
  },
  {
    id: 'llm-q72',
    question: 'Different models may tokenize the same text:',
    choices: [
      'Identically always',
      'Differently based on their tokenizer',
      'Only in English',
      'Never successfully',
    ],
    correctAnswer: 1,
    explanation:
      'Different models use different tokenizers and may tokenize the same text differently.',
  },
  {
    id: 'llm-q73',
    question: 'Token IDs are:',
    choices: [
      'Random numbers',
      'Numerical representations of tokens',
      'User passwords',
      'Error codes',
    ],
    correctAnswer: 1,
    explanation: 'Token IDs are numerical representations that models use internally.',
  },
  {
    id: 'llm-q74',
    question: 'The vocabulary size of modern LLMs is typically:',
    choices: [
      '100-1,000 tokens',
      '1,000-10,000 tokens',
      '30,000-100,000 tokens',
      '1 million+ tokens',
    ],
    correctAnswer: 2,
    explanation: 'Modern LLMs typically have vocabularies of 30,000-100,000 tokens.',
  },
  {
    id: 'llm-q75',
    question: 'Tokenization affects context windows because:',
    choices: [
      'Windows are made of tokens',
      'Context limits are measured in tokens, not words',
      'Tokens break windows',
      "It doesn't affect context",
    ],
    correctAnswer: 1,
    explanation:
      'Context window limits are measured in tokens, making tokenization crucial for planning.',
  },

  // Context and Attention (76-85)
  {
    id: 'llm-q76',
    question: 'What is a context window?',
    choices: [
      'A GUI element',
      'Maximum text the model can process at once',
      'A type of attention',
      'Training duration',
    ],
    correctAnswer: 1,
    explanation: 'Context window is the maximum amount of text a model can process at once.',
  },
  {
    id: 'llm-q77',
    question: 'Typical context window sizes range from:',
    choices: ['10-100 tokens', '100-1,000 tokens', '4,000-1,000,000+ tokens', 'Unlimited'],
    correctAnswer: 2,
    explanation: 'Modern LLMs have context windows ranging from 4,000 to over 1 million tokens.',
  },
  {
    id: 'llm-q78',
    question: 'Attention mechanisms allow models to:',
    choices: [
      'Pay attention to users',
      'Focus on relevant parts of the input',
      'Reduce processing time',
      'Eliminate errors',
    ],
    correctAnswer: 1,
    explanation: 'Attention allows models to focus on relevant parts of the input when processing.',
  },
  {
    id: 'llm-q79',
    question: 'Self-attention means:',
    choices: [
      'The model is self-aware',
      'Tokens attend to other tokens in the same sequence',
      'Attention to the self',
      'Automatic attention',
    ],
    correctAnswer: 1,
    explanation: 'Self-attention means tokens can attend to all other tokens in the same sequence.',
  },
  {
    id: 'llm-q80',
    question: 'Multi-head attention provides:',
    choices: [
      'Multiple models',
      'Different types of attention in parallel',
      'Faster processing only',
      'Error correction',
    ],
    correctAnswer: 1,
    explanation: 'Multi-head attention provides different types of attention patterns in parallel.',
  },
  {
    id: 'llm-q81',
    question: 'When context window is exceeded, the model:',
    choices: ['Crashes', 'Forgets earlier information', 'Becomes smarter', 'Speeds up'],
    correctAnswer: 1,
    explanation: 'When context window is exceeded, the model cannot access earlier information.',
  },
  {
    id: 'llm-q82',
    question: 'Long-range dependencies are handled through:',
    choices: ['Longer cables', 'Attention mechanisms', 'More memory', 'Faster processors'],
    correctAnswer: 1,
    explanation: 'Attention mechanisms enable models to handle long-range dependencies in text.',
  },
  {
    id: 'llm-q83',
    question: 'Position encoding is necessary because:',
    choices: [
      'Tokens need GPS',
      'Transformers lack inherent sequence order',
      "It's not necessary",
      'For error tracking',
    ],
    correctAnswer: 1,
    explanation:
      "Position encoding is needed because transformers don't inherently understand sequence order.",
  },
  {
    id: 'llm-q84',
    question: 'The attention score between two tokens represents:',
    choices: [
      'Their spelling similarity',
      'Their relevance to each other',
      'Their position',
      'Their color',
    ],
    correctAnswer: 1,
    explanation: 'Attention scores represent how relevant tokens are to each other in context.',
  },
  {
    id: 'llm-q85',
    question: 'Context accumulation means:',
    choices: [
      'Saving context for later',
      'Building understanding as more tokens are processed',
      'Adding numbers',
      'Memory overflow',
    ],
    correctAnswer: 1,
    explanation:
      'Context accumulation refers to building understanding progressively as tokens are processed.',
  },

  // Generation and Sampling (86-100)
  {
    id: 'llm-q86',
    question: 'LLMs generate text by:',
    choices: [
      'Retrieving from a database',
      'Predicting the next most likely token',
      'Random selection',
      'Following strict rules',
    ],
    correctAnswer: 1,
    explanation: 'LLMs generate text by predicting the next most likely token based on context.',
  },
  {
    id: 'llm-q87',
    question: 'Temperature in LLM generation controls:',
    choices: ['Physical heat', 'Processing speed', 'Randomness/creativity of output', 'Model size'],
    correctAnswer: 2,
    explanation: 'Temperature controls the randomness and creativity of generated output.',
  },
  {
    id: 'llm-q88',
    question: 'A temperature of 0 results in:',
    choices: ['No output', 'Deterministic output (always same)', 'Maximum creativity', 'Errors'],
    correctAnswer: 1,
    explanation:
      'Temperature 0 results in deterministic output, always choosing the most likely token.',
  },
  {
    id: 'llm-q89',
    question: 'High temperature (>1.0) produces:',
    choices: [
      'Faster output',
      'More creative/diverse output',
      'More accurate output',
      'Shorter output',
    ],
    correctAnswer: 1,
    explanation: 'High temperature produces more creative and diverse output.',
  },
  {
    id: 'llm-q90',
    question: 'Greedy decoding means:',
    choices: [
      'Using minimal resources',
      'Always choosing the highest probability token',
      'Generating quickly',
      'Saving tokens',
    ],
    correctAnswer: 1,
    explanation: 'Greedy decoding always chooses the highest probability token at each step.',
  },
  {
    id: 'llm-q91',
    question: 'Top-k sampling limits choices to:',
    choices: [
      'The first k tokens',
      'The k most likely tokens',
      'Random k tokens',
      'The last k tokens',
    ],
    correctAnswer: 1,
    explanation: 'Top-k sampling limits selection to the k most likely tokens.',
  },
  {
    id: 'llm-q92',
    question: 'Top-p (nucleus) sampling:',
    choices: [
      'Uses nuclear power',
      'Selects tokens until cumulative probability reaches p',
      'Only works at night',
      'Requires special hardware',
    ],
    correctAnswer: 1,
    explanation:
      'Top-p sampling selects tokens until their cumulative probability reaches threshold p.',
  },
  {
    id: 'llm-q93',
    question: 'Beam search involves:',
    choices: [
      'Using lasers',
      'Exploring multiple generation paths in parallel',
      'Searching the internet',
      'Finding errors',
    ],
    correctAnswer: 1,
    explanation:
      'Beam search explores multiple generation paths in parallel to find better outputs.',
  },
  {
    id: 'llm-q94',
    question: 'Repetition penalty is used to:',
    choices: [
      'Punish users',
      'Reduce likelihood of repeating recent tokens',
      'Increase repetition',
      'Speed up generation',
    ],
    correctAnswer: 1,
    explanation: 'Repetition penalty reduces the likelihood of repeating recently used tokens.',
  },
  {
    id: 'llm-q95',
    question: 'Stop sequences are:',
    choices: [
      'Emergency buttons',
      'Tokens/strings that signal generation should end',
      'Errors',
      'Pauses in processing',
    ],
    correctAnswer: 1,
    explanation:
      'Stop sequences are specific tokens or strings that signal generation should stop.',
  },
  {
    id: 'llm-q96',
    question: 'The probability distribution over vocabulary:',
    choices: [
      'Is always uniform',
      'Sums to 100% for next token prediction',
      'Is random',
      "Doesn't exist",
    ],
    correctAnswer: 1,
    explanation: 'The probability distribution over all possible next tokens always sums to 100%.',
  },
  {
    id: 'llm-q97',
    question: 'Few-shot prompting works by:',
    choices: [
      'Training the model',
      'Providing examples in the prompt for pattern matching',
      'Using small models',
      'Reducing shots',
    ],
    correctAnswer: 1,
    explanation:
      'Few-shot prompting provides examples in the prompt for the model to pattern match.',
  },
  {
    id: 'llm-q98',
    question: 'Chain-of-thought prompting encourages:',
    choices: ['Faster processing', 'Step-by-step reasoning', 'Shorter outputs', 'Random thoughts'],
    correctAnswer: 1,
    explanation: 'Chain-of-thought prompting encourages models to show step-by-step reasoning.',
  },
  {
    id: 'llm-q99',
    question: 'Prompt engineering is important because:',
    choices: [
      'Engineers need prompts',
      'Input phrasing significantly affects output quality',
      "It's not important",
      'Models require it',
    ],
    correctAnswer: 1,
    explanation: 'Input phrasing and structure significantly affect the quality of model outputs.',
  },
  {
    id: 'llm-q100',
    question: 'The main difference between training and inference is:',
    choices: [
      'Training updates weights, inference uses frozen weights',
      'They are the same',
      'Inference is training',
      'Training is faster',
    ],
    correctAnswer: 0,
    explanation:
      'Training updates model weights while inference uses frozen weights to generate outputs.',
  },
];
